import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useStore } from "../hooks-store/store";
import { validateUser } from "../pages/login/validate-user";
import { SESSIONSTORAGEKEYS } from "../common/constants";

const ProtectedRoutes = () => {
  const [store, dispatch] = useStore();
  const token = validateUser(store, dispatch);
  const location = useLocation();
  if (!token) {
    sessionStorage.setItem(SESSIONSTORAGEKEYS.TO_REDIRECT_PAGE, location.pathname);
  }
  return token ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoutes;
